<template>
  <div class="note-component bordered-box">
    <!-- <div class="note-component__row row-user d-flex align-items-center">
      <figure class="note-component__avatar">
        <img :src="user.user_avatar" :alt="user.user_name">
      </figure>
      <span class="note-component__user-name">{{ user.user_name }}</span>
    </div> -->
    <div class="note-component__row row-textarea">
      <textarea
        :value="value"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  props: ['name', 'value'],
  computed: {
    placeholder() {
      return `This is your personal space to write your notes on ${this.name}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
@import '../panel/scss/tab.scss';

.note-component {
  .note-component__row {
    &.row-user {
      padding: 8px;
      border-bottom: 1px solid #e6e7eb;

      .note-component__avatar {
        width: 20px;
        height: 20px;
        margin: 0;
        border-radius: 50%;
        overflow: hidden;

        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
      .note-component__user-name {
        margin-left: 8px;
        font-size: 10px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0.32px;
        color: $gray-light;
      }
    }
    &.row-textarea {
      padding: 15px 8px;

      textarea {
        width: 100%;
        min-height: 360px;
        border: none;
        outline: none;
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: normal;
        color: $gray-dark;
        resize: none;
      }
    }
  }
}
</style>
